import { useState, useEffect } from 'react';
import api from '../../api';
import { downloadExcel } from '../../utils/excelExport';
import MonthSelect from '../../components/MonthSelect';

const money = (n) => `${Math.round(Number(n || 0)).toLocaleString('ru')} ₽`;
const pct = (n) => n == null ? '—' : `${Number(n).toFixed(2)}%`;

function thisMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

const ROWS = [
  { key: 'revenue', label: 'Выручка', bold: true },
  { key: 'variable', label: 'Прямые затраты', sign: '-' },
  { key: 'marginProfit', label: 'Маржинальная прибыль', bold: true },
  { key: 'marginRentability', label: 'Маржинальная рентабельность, %', pct: true },
  { key: 'fixed', label: 'Накладные расходы', sign: '-' },
  { key: 'grossProfit', label: 'Результат после накладных', bold: true },
  { key: 'commercial', label: 'Коммерческие расходы', sign: '-' },
  { key: 'administrative', label: 'Административные расходы', sign: '-' },
  { key: 'depreciation', label: 'Амортизация', sign: '-' },
  { key: 'operatingProfit', label: 'Операционная прибыль', bold: true },
  { key: 'operatingRentability', label: 'Операционная рентабельность, %', pct: true },
  { key: 'tax', label: 'Налоги', sign: '-' },
  { key: 'financialIncome', label: 'Финансовые доходы' },
  { key: 'interest', label: 'Проценты по кредитам', sign: '-' },
  { key: 'netProfit', label: 'Чистая прибыль', bold: true },
  { key: 'netRentability', label: 'Итоговая рентабельность, %', pct: true },
];

export default function PnL() {
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get('/finance/reports/pnl', { params: { month } }).then(r => setData(r.data)).finally(() => setLoading(false));
  }, [month]);

  const exportPnl = () => downloadExcel(
    `ОПиУ ${month}`,
    ['Показатель', 'Значение'],
    ROWS.map(r => [r.label, r.pct ? pct(data[r.key]) : money(data[r.key])])
  );

  return (
    <div>
      <div className="toolbar">
        <label style={{ margin: 0 }}>Месяц:</label>
        <MonthSelect value={month} onChange={setMonth} allowEmpty={false} />
        <div className="toolbar-spacer" />
        {data && <button className="btn-secondary btn-sm" onClick={exportPnl}>Экспорт в Excel</button>}
      </div>

      {loading ? <div className="loading-text">Загрузка...</div> : !data ? <div className="empty-state">Нет данных</div> : (
        <>
          <div className="card mb-2"><b>По начислению — принятые работы и затраты, без возмещаемого НДС</b><p>Документов за месяц: {data.documentCount}. {data.incomplete ? 'Период не закрыт: результат предварительный. Отсутствие начислений не означает нулевую прибыль бизнеса.' : 'Период закрыт.'}</p></div>
          {data.unclassified > 0 && (
            <div className="error-msg mb-2">
              Денежные движения без статьи: {money(data.unclassified)}. Они видны в ДДС; наличие оплаты само по себе не подтверждает расход или выручку ОПиУ.
            </div>
          )}
          <div className="table-wrap">
            <table>
              <tbody>
                {ROWS.map(r => (
                  <tr key={r.key}>
                    <td style={{ fontWeight: r.bold ? 700 : 400 }}>{r.label}</td>
                    <td style={{ textAlign: 'right', fontWeight: r.bold ? 700 : 400 }}>
                      {r.sign === '-' && Number(data[r.key]) > 0 ? '− ' : ''}{r.pct ? pct(data[r.key]) : money(data[r.key])}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
